export const actionLabels = { accept: "Accept booking", start: "Start service", ready: "Mark ready", complete: "Complete service", cancel: "Cancel booking", reject: "Reject booking", no_show: "Mark no-show" };
export const blockers = {
  permission_denied: "You do not have permission for this action.",
  linked_state_conflict: "The booking and order need review before this action.",
  reservation_state_conflict: "The reservation needs review before this action.",
  booking_terminal: "The booking's current state does not allow this action.",
  service_not_started: "Available at or after the appointment start. Refresh then.",
  order_required: "This action requires a linked order.",
  order_transition_invalid: "The order's current state does not allow this action.",
  checkout_not_ready: "Required checkout details must be completed before acceptance.",
};
export const attentionLabels = {
  manual_refund_review: "Manual refund review", provider_resolution_required: "Payment reconciliation",
  collection_resolution_required: "Outstanding collection", no_show_financial_resolution: "Resolve no-show finances",
  linked_state_conflict: "Booking and order need review", linked_order_unavailable: "Order link unavailable",
  frozen_total_unavailable: "Frozen total unavailable", reservation_state_conflict: "Reservation needs review",
};
export const enumKey = value => typeof value === "string" ? value.replace(/[^a-z0-9]/gi, "").toLowerCase() : "";
export const humanize = value => typeof value === "string" && value.trim()
  ? value.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/[_-]/g, " ").replace(/^./, c => c.toUpperCase()) : "Not available";
export function displayAnswer(value) {
  if (Array.isArray(value)) return value.map(displayAnswer).filter(x => x !== "Not provided").join(", ") || "Not provided";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  return typeof value === "string" && value.trim() ? value : "Not provided";
}
export function appointmentTime(value, zone) {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return "Time unavailable";
  try { return new Intl.DateTimeFormat(undefined, { timeZone: zone || "UTC", dateStyle: "medium", timeStyle: "short" }).format(date); }
  catch { return `${date.toISOString().replace("T", " ").slice(0, 16)} UTC`; }
}
export function frozenMoney(total) {
  if (!total || typeof total.finalPayableTotal !== "number" || !Number.isFinite(total.finalPayableTotal) || !total.currency) return "Total unavailable";
  try { return new Intl.NumberFormat(undefined, { style: "currency", currency: total.currency }).format(total.finalPayableTotal); }
  catch { return `${total.finalPayableTotal} ${total.currency}`; }
}
export function bookingTimeline(workspace, orderDetail) {
  const b = workspace.booking;
  const events = [
    [b.confirmedAtUtc, "Booking", "Appointment confirmed"], [b.completedAtUtc, "Booking", "Service completed"],
    [b.cancelledAtUtc, "Booking", "Booking cancelled", b.cancellationReason], [b.noShowAtUtc, "Booking", "No-show recorded"],
  ];
  if (workspace.orderLinkState === "linked") {
    events.push([workspace.order?.total?.finalizedAtUtc, "Order", "Payable total frozen"]);
    if (orderDetail?.id === workspace.order?.id && orderDetail.version === workspace.order.version) {
      (orderDetail.history || []).forEach(item => events.push([item.createdAtUtc, "Order", humanize(item.newStatus), item.reason]));
    }
    const latest = workspace.order?.payment?.latestAttempt;
    if (enumKey(latest?.status) === "paid" && latest.verifiedAtUtc) events.push([latest.verifiedAtUtc, "Payment", "Latest attempt verified paid"]);
  }
  return events.filter(([at]) => at && !Number.isNaN(Date.parse(at))).sort((a, b) => Date.parse(b[0]) - Date.parse(a[0]));
}

export function lifecycleLabel(workspace, code) {
  if (enumKey(workspace?.booking?.status) === "noshow" && ["cancel", "reject"].includes(code)) return code === "cancel" ? "Cancel order" : "Reject order";
  return actionLabels[code];
}
